import React, { useState, useEffect } from 'react';
import './AnnouncementBar.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const AnnouncementBar = () => {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/announcement`)
      .then(r => r.json())
      .then(data => setAnnouncement(data))
      .catch(() => {});
  }, []);

  if (!announcement || !announcement.is_active || !announcement.text.trim()) return null;

  return (
    <div className="announcement-bar" role="banner">
      <p
        className="announcement-bar-text"
        dangerouslySetInnerHTML={{ __html: announcement.text }}
      />
    </div>
  );
};

export default AnnouncementBar;
